import moment from "moment";
import diffInSeconds from "./diffInSeconds";

export default {
  closestDeadline(passDeadline) {
    let deadlines = [
      moment(passDeadline.certificate),
      moment(passDeadline.installation)
    ].filter(x => diffInSeconds(x) > 0);
    deadlines.sort((a, b) => {
      const dA = Math.abs(a - moment()),
        dB = Math.abs(b - moment());

      if (dA < dB) {
        return -1;
      } else if (dA > dB) {
        return 1;
      } else {
        return 0;
      }
    });

    return deadlines[0] && deadlines[0].isValid() ? deadlines[0] : null;
  },

  isAllDeadlinesPassesReached(passDeadline) {
    const diffInCertificate = diffInSeconds(passDeadline.certificate) || 0;
    const diffInInstallation = diffInSeconds(passDeadline.installation) || 0;
    return (
      !(passDeadline.certificate || passDeadline.installation) ||
      (diffInCertificate < 0 && diffInInstallation < 0)
    );
  },

  showWarning(passDeadline) {
    return (
      diffInSeconds(this.closestDeadline(passDeadline)) <= 60 * 60 * 24 * 10 &&
      !this.isAllDeadlinesPassesReached(passDeadline)
    );
  }
};
